import React from 'react';
import { IProps } from './types';
import SliderAdvanced from 'components/SliderAdvanced';
import { Activity as ActivityModel } from 'bff/models/info/activity';
import _ from 'lodash';
// import moment from 'moment';
import moment from 'moment-timezone';
import { ActivityCount } from 'constants/enums/showCount.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';

const Activity: React.FC<IProps> = (props) => {
  /**
   * @description 建立熱門活動
   */
  const handleCreateActivitys = () => {
    if (!props.activities || props.activities.ACTIVITY.length === 0) return;
    let imgCount = 0;
    const child = _.map(props.activities.ACTIVITY, (activity:ActivityModel, index:number) => {
      if (moment() > moment(activity.END_DATE)) return;
      imgCount += 1;
      if (imgCount > ActivityCount.Car) return;

      try {
        return (
          <SliderAdvanced.Item title={activity.TITLE} desc={activity.BRIEF} activityUrl={activity.ACTIVITY_URL} key={index}>
            <span>
              <img src={activity.IMAGE_NAME_PC} alt="" className="activity__slider-image-pc" />
              <img src={activity.IMAGE_NAME_MOBILE} alt="" className="activity__slider-image-mobile" />
            </span>
          </SliderAdvanced.Item>
        );
      } catch (ex) {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          title: '無法取得熱門活動圖片'
        });
        return null;
      }
    });

    return (
      <SliderAdvanced
        name="activity__slider"
        moreBlockText={props.moreActivityText}
        moreBlockLink={props.activities.MORE_ACTIVITY_URL}
      >
        {child}
      </SliderAdvanced>
    );
  };
  return (
    <div className="activity">
      <div className="template-container">
        <div className="template-content">
          <div className="activity__title-section">
            <div className="activity__title">熱門活動</div>
          </div>
        </div>
        <div className="activity__slider-section">
          <div className="activity__slider-container">
            {handleCreateActivitys()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Activity;
